import React, { createContext, useContext, MouseEvent } from 'react';
import { ConsultUserBasicInfo } from '@remodeling/remodeling-manager';
import { RadioType } from '@/feat-components/SeqConsult/hooks/useSeqSearchAddressForm';
import { Step, ConsultType } from '@/types/seq-consult';

interface SeqConsultContextType {
  step: Step;
  consultType: ConsultType;
  currentStepIndex: number;
  handleChangeStep: (nextStep: Step) => void;
  handleNext: () => void;
  handlePrev: () => void;
  handleSubmit: (e: MouseEvent<HTMLButtonElement>) => void;
  userBasicInfo: ConsultUserBasicInfo | undefined;
  defaultRadio: RadioType;
  handleChangeIsDefaultAddress: (defaultRadio: RadioType) => void;
  handleChangeTelCertificated: (nextCertificated: boolean) => void;
  isTelCertificated: boolean;
  agentEmployeeNo: string;
  workAvailableAreas?: string[];
  isOpenWorkableBottomSheet: boolean;
  handleOpenBottomSheet: () => void;
  handleCloseBottomSheet: () => void;
}

const SeqConsultContext = createContext<SeqConsultContextType>(
  {} as SeqConsultContextType,
);

export const useSeqConsultContext = () => {
  const context = useContext(SeqConsultContext);
  if (context === undefined) {
    throw new Error(
      'useSeqConsultFormContext must be used within a SeqConsultContext',
    );
  }
  return context;
};

export interface SeqConsultContextProps {
  children: React.ReactNode;
  value: SeqConsultContextType;
}

export const SeqConsultProvider = ({
  children,
  value,
}: SeqConsultContextProps) => {
  return (
    <SeqConsultContext.Provider value={{ ...value }}>
      {children}
    </SeqConsultContext.Provider>
  );
};

export default SeqConsultProvider;
